<template>
  <v-card class="elevation-4 hidden-sm-and-down">
    <v-card-text>
      <slot name="header"></slot>
      <highcharts
        ref="highcharts"
        v-if="options"
        :options="options"
      ></highcharts>
      <slot name="footer"></slot>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "CorePieChart",
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    subtitle: {
      type: String,
      required: false,
      default: ''
    },
    series: {
      type: Array,
      required: true
    },
    format: {
      type: String,
      required: false,
      default: 'currency'
    }
  },
  data() {
    return {
      options: false
    }
  },
  computed: {
    ...mapGetters(['getFacilityName'])
  },
  created() {
    let colors = [
      '#409ed4',
      '#fa782e',
      '#6aac4c',
      '#ffbc0e',
      '#a5a5a5',
      '#f45055',
      '#f45055',
      '#2677c4',
      '#335b98'
    ]

    this.options = {
      colors: colors,
      chart: {
        // styledMode: true,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      title: {
        text: this.title
      },
      subtitle: {
        text: this.subtitle
      },
      exporting: {
        filename:
          this.getFacilityName.replace(new RegExp(' ', 'g'), '_') +
          '__DataExport'
      },
      credits: {
        enabled: false
      },
      tooltip: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: this.getPointFormat(),
            style: {
              fontSize: '15px',
              fontWeight: 500
            }
          }
        }
      },
      series: this.series
    }
  },
  methods: {
    getPointFormat() {
      // default is just formatted
      let fmt = '<b>{point.name}</b>:' + '<br/>{point.y: ,.2f}' 

      if (this.format == 'float') {
        fmt = '<b>{point.name}</b>:' + '<br/>{point.y: ,.2f}'
      } else if (this.format == 'integer') {
        fmt = '<b>{point.name}</b>:' + '<br/>{point.y: ,.0f}'
      } else if (this.format == 'percent') {
        fmt = '<b>{point.name}</b>:' + '<br/>{point.y: ,.2f}%'
      } else if (this.format == 'currency') {
        fmt = '<b>{point.name}</b>:' + '<br/>${point.y: ,.2f}'
      }
      return fmt
    }
  }
}
</script>
